type ApiVersions = {
  readonly v1: string | undefined;
  readonly v2: string | undefined;
};

export const API_VERSIONS: Readonly<ApiVersions> = Object.freeze({
  v1: import.meta.env.VITE_API_URL,
  v2: import.meta.env.VITE_API_URL_V2,
});


export type ApiVersionKey = keyof typeof API_VERSIONS;